import { FetchState } from 'src/enums/FetchState';

import { fetchRequest } from 'src/utils/fetchRequest';

export async function favouritesRequest(detailed?: boolean, sortOption?: number): Promise<{ data: []; state: FetchState }> {
	const slug = detailed
		? process.env.NEXT_PUBLIC_SITECORE_FAVOURITE_GETUSERFAVOURITESDETAILED
		: process.env.NEXT_PUBLIC_SITECORE_FAVOURITE_GETUSERFAVOURITES;
	const applicationParams = 'applicationId=' + process.env.NEXT_PUBLIC_FAVOURITES_APPLICATIONID;
	const sortOptionParams = sortOption ? 'sortOption=' + sortOption : '';
	const endpoint = `${process.env.NEXT_PUBLIC_SITECORE_FAVOURITE}${slug}?${applicationParams}&${sortOptionParams}`;

	try {
		const response = await fetchRequest(endpoint);

		if (!response.ok) {
			throw response.statusText;
		}

		const data = await response.json();

		if (data.error) {
			throw data.error;
		}

		if (!data.length) {
			return {
				data: [],
				state: FetchState.WARNING,
			};
		}

		return { data, state: FetchState.SUCCESS };
	} catch (error) {
		return {
			data: [],
			state: FetchState.ERROR,
		};
	}
}
